/**
 * MADERINCO-PLANTILLAS-UX-T1 (T147/T148): los buscadores del catalogo en el armador del demo, sin DOM, para el check.
 *
 * Todo sale de la plantilla que manda GET /presupuestos/plantilla, ya normalizada (plantilla.js). Nunca se infiere un
 * APU ni un precio: el item entra con lo que trae la plantilla.
 *   - busqueda: todas las palabras escritas tienen que estar en la descripcion o en el nombre del grupo del catalogo
 *   - "Agregar otro item del catalogo" de una linea: la misma busqueda con filtro por grupo (#36553)
 * Josse 28-oct (#36553): los grupos del catalogo ya no son secciones del armador; con eso se retiraron la pregunta de
 * tipo o material, los complementos ("Suele ir con"), "Abrir seccion" y la seccion sugerida para empezar.
 *
 * @module application/presupuestos/guiaPlantilla
 */

/** minusculas, sin tildes y sin signos: "Teja UPVC," y "teja upvc" son lo mismo. */
export function normalizar(s) {
  return String(s ?? '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
}

/** "techo" no es un grupo del catalogo: puede ser cubierta (afuera) o cielo raso (adentro). */
export function pideAclararTecho(q) {
  return /\btecho/.test(normalizar(q));
}

/**
 * Busqueda especifica en toda la plantilla: cada palabra escrita (2+ letras) tiene que estar en la descripcion o en
 * el nombre del grupo. Devuelve {resultados:[{seccion, item}], total}. Menos de 2 letras = sin busqueda.
 */
export function buscarEnPlantilla(plantilla, q, max = 8) {
  const terminos = normalizar(q).split(' ').filter((t) => t.length >= 2);
  if (!terminos.length) return { resultados: [], total: 0 };
  const todos = [];
  for (const s of plantilla?.secciones || []) {
    const ns = normalizar(s.nombre);
    for (const it of s.items || []) {
      const texto = ns + ' ' + normalizar(it.descripcion);
      if (terminos.every((t) => texto.includes(t))) todos.push({ seccion: s, item: it });
    }
  }
  return { resultados: todos.slice(0, max), total: todos.length };
}

/**
 * "Agregar otro item del catalogo" dentro de una linea (#36553 punto 2): como buscarEnPlantilla, pero con filtro por
 * grupo del catalogo (la clave de una seccion de la plantilla). Con grupo elegido y sin palabras, lista el grupo entero:
 * asi todo item del catalogo se alcanza (grupo -> su lista) aunque no se sepa la palabra.
 */
export function buscarEnCatalogo(plantilla, q, { grupo = '', max = 12 } = {}) {
  const secciones = (plantilla?.secciones || []).filter((s) => !grupo || s.clave === grupo);
  if (grupo && !normalizar(q).split(' ').some((t) => t.length >= 2)) {
    const todos = secciones.flatMap((s) => (s.items || []).map((item) => ({ seccion: s, item })));
    return { resultados: todos.slice(0, max), total: todos.length };
  }
  return buscarEnPlantilla({ secciones }, q, max);
}
